var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSensor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1028.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21 1035.4v4 4 6c0 1.1-0.895 2-2 2h-14c-1.1046 0-2-0.9-2-2v-6-4-4h18z",
    fill: "#7f8c8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 1034.4v4 4 6c0 1.1 0.8954 2 2 2h14c1.105 0 2-0.9 2-2v-6-4-4h-18z",
    fill: "#95a5a6"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3.9998,
    width: 5,
    y: 1046.4,
    x: 15,
    fill: "#7f8c8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 1c-1.1046 0-2 0.8954-2 2v3 1 2 2 2 1 3c0 1.105 0.8954 2 2 2h14c1.105 0 2-0.895 2-2v-3-3-4-1-3c0-1.1046-0.895-2-2-2h-14z",
    transform: "translate(0 1028.4)",
    fill: "#bdc3c7"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "translate(0 1028.4)",
    height: 1,
    width: 3,
    y: 20,
    x: 16,
    fill: "#f1c40f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensor);
export default __webpack_public_path__ + "static/media/sensor.de7875a6c1c7f40cb5b3d7fdeded8184.svg";
export { ForwardRef as ReactComponent };